import { useEffect, useRef, useState } from "react";

/** A short message at the bottom, gone after a few seconds. */
export function useToast() {
  const [text, setText] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => void (timer.current && clearTimeout(timer.current)), []);
  return {
    text,
    show(message: string) {
      setText(message);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setText(null), 4500);
    },
    hide: () => setText(null),
  };
}

export function Toast({ toast }: { toast: ReturnType<typeof useToast> }) {
  if (!toast.text) return null;
  return (
    <div className="toast" role="status" data-testid="toast">
      <span>{toast.text}</span>
      <button onClick={toast.hide}>OK</button>
    </div>
  );
}
